:host {
  @apply block;
}

:host([scale="s"]) {
  .controls-wrapper {
    @apply h-6;
  }
}

:host([scale="m"]) {
  .controls-wrapper {
    @apply h-8;
  }
}

:host([scale="l"]) {
  .controls-wrapper {
    @apply h-11;
  }
}

:host(:not([editing-enabled]):not([disabled])) {
  .wrapper {
    &:hover {
      @apply bg-foreground-2;
    }
  }
}

.wrapper {
  @apply bg-foreground-1
    transition-default
    box-border
    flex
    justify-between;

  .input-wrapper {
    @apply flex-1;
  }
}

.controls-wrapper {
  @apply flex;
}

@include disabled() {
  .cancel-editing-button-wrapper {
    @apply border-color-2;
  }
}

@include base-component();
